import React, { useState } from 'react';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

function Footer({ darkMode }) {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const footerClass = darkMode 
    ? 'bg-gray-900 text-white border-gray-700' 
    : 'bg-gray-50 text-gray-800 border-gray-200';

  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        {/* 배경 오버레이 */}
        <div 
          className="absolute inset-0 bg-black bg-opacity-50"
          onClick={onClose}
        ></div>
        
        {/* 모달 콘텐츠 */}
        <div className={`relative max-w-4xl max-h-[80vh] w-full rounded-2xl shadow-2xl overflow-hidden ${
          darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
        }`}>
          {/* 모달 헤더 */}
          <div className={`sticky top-0 px-6 py-4 border-b flex justify-between items-center ${
            darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'
          }`}>
            <h2 className="text-2xl font-bold">{title}</h2>
            <button
              onClick={onClose}
              className={`p-2 rounded-lg transition-all duration-300 hover:bg-opacity-20 ${
                darkMode ? 'hover:bg-white' : 'hover:bg-gray-500'
              }`}
            >
              <span className="text-2xl">✕</span>
            </button>
          </div>
          
          {/* 모달 본문 */}
          <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]">
            {children}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <footer className={`border-t mt-auto ${footerClass}`}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          
          {/* 메인 푸터 콘텐츠 - 깔끔한 2칸 구성 + 위쪽 정렬 */}
          <div className="grid md:grid-cols-2 gap-8 mb-8 items-start">
            
            {/* 왼쪽: 서비스 정보 & 특징 */}
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="text-3xl">😺</div>
                <div>
                  <h3 className="text-xl font-black bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    면접톡
                  </h3>
                  <p className="text-sm opacity-75">4단계 체계적 면접 완전 정복</p>
                </div>
              </div>
              
              <p className="text-sm leading-relaxed mb-6 opacity-90">
                면접톡은 전문 직업상담사가 개발한 면접 연습 서비스로 취업준비 및 입시준비생들이 언제 어디서나 효과적으로 면접을 연습할 수 있습니다.
              </p>
              
              {/* 서비스 특징 - 예쁜 배지 스타일 */}
              <div className="grid grid-cols-2 gap-3">
                <div className={`flex items-center p-3 rounded-lg ${
                  darkMode ? 'bg-green-900 bg-opacity-30' : 'bg-green-50'
                }`}>
                  <span className="text-green-500 text-xl mr-2">✅</span>
                  <span className="text-sm font-medium">완전 무료</span>
                </div>
                <div className={`flex items-center p-3 rounded-lg ${
                  darkMode ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50'
                }`}>
                  <span className="text-blue-500 text-xl mr-2">🔒</span>
                  <span className="text-sm font-medium">개인정보 보호</span>
                </div>
                <div className={`flex items-center p-3 rounded-lg ${
                  darkMode ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50'
                }`}>
                  <span className="text-purple-500 text-xl mr-2">📱</span>
                  <span className="text-sm font-medium">모바일 지원</span>
                </div>
                <div className={`flex items-center p-3 rounded-lg ${
                  darkMode ? 'bg-orange-900 bg-opacity-30' : 'bg-orange-50'
                }`}>
                  <span className="text-orange-500 text-xl mr-2">🎯</span>
                  <span className="text-sm font-medium">38개 직무</span>
                </div>
              </div>
            </div>

            {/* 오른쪽: 외부 링크 & 문의 정보 & 법적 문서 */}
            <div>
              <h4 className="font-bold mb-6 text-lg flex items-center">
                <span className="text-2xl mr-2">🌟</span>
                링크 & 문의
              </h4>
              
              {/* 상단: 블로그 + 법적 문서들 가로 배치 */}
              <div className="grid grid-cols-3 gap-2 mb-6">
                <a 
                  href="https://jobangel.tistory.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={`flex items-center justify-center px-2 py-3 rounded-lg font-medium transition-all duration-300 hover:scale-105 shadow-md hover:shadow-lg text-xs ${
                    darkMode 
                      ? 'bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white' 
                      : 'bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white'
                  }`}
                >
                  <span className="text-sm mr-1">🌟</span>
                  <span>취업천사블로그</span>
                </a>
                
                <button
                  onClick={() => setShowPrivacyModal(true)}
                  className={`flex items-center justify-center px-2 py-3 rounded-lg transition-all duration-300 hover:scale-105 text-xs ${
                    darkMode 
                      ? 'text-gray-300 hover:text-blue-400 hover:bg-gray-800 bg-gray-700' 
                      : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50 bg-gray-100'
                  }`}
                >
                  <span className="mr-1">📋</span>
                  <span className="font-medium">개인정보처리방침</span>
                </button>
                
                <button
                  onClick={() => setShowTermsModal(true)}
                  className={`flex items-center justify-center px-2 py-3 rounded-lg transition-all duration-300 hover:scale-105 text-xs ${
                    darkMode 
                      ? 'text-gray-300 hover:text-blue-400 hover:bg-gray-800 bg-gray-700' 
                      : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50 bg-gray-100'
                  }`}
                >
                  <span className="mr-1">📜</span>
                  <span className="font-medium">이용약관</span>
                </button>
              </div>

              {/* 하단: 문의 정보 */}
              <div className={`p-4 rounded-xl ${
                darkMode ? 'bg-gray-800' : 'bg-gray-100'
              }`}>
                <h5 className="font-bold mb-3 flex items-center">
                  <span className="text-lg mr-2">📧</span>
                  문의하기
                </h5>
                <a 
                  href="mailto:job1004jane@gmail.com" 
                  className={`font-mono text-sm font-semibold break-all transition-colors duration-300 ${
                    darkMode 
                      ? 'text-blue-400 hover:text-blue-300' 
                      : 'text-blue-600 hover:text-blue-800'
                  }`}
                >
                  job1004jane@gmail.com
                </a>
                <p className="text-xs opacity-75 mt-2">
                  기타사항 및 컨설팅 문의는 이메일을 보내주세요.
                </p>
              </div>
            </div>
          </div>

          {/* 구분선 */}
          <div className={`border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'} pt-4`}>
            
            {/* 하단 정보 - 중앙정렬 */}
            <div className="text-center mb-3">
              <p className="text-sm opacity-75 mb-1">
                &copy; 2025 면접톡 AI 모의면접 서비스. All rights reserved.
              </p>
            </div>
            
            {/* 기술 정보 - 예쁜 배지 스타일 */}
            <div className={`text-center p-3 rounded-xl ${
              darkMode ? 'bg-blue-900 bg-opacity-20' : 'bg-blue-50'
            }`}>
              <p className="text-xs opacity-75">
                이 서비스는 <span className="font-semibold">웹서비스에 최적화 되어있습니다.</span>
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* 개인정보처리방침 모달 */}
      <Modal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        title="📋 개인정보처리방침"
      >
        <PrivacyPolicy />
      </Modal>

      {/* 이용약관 모달 */}
      <Modal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
        title="📜 이용약관"
      >
        <TermsOfService />
      </Modal>
    </>
  );
}

export default Footer;